import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { Slot } from "radix-ui";

import { cn } from "@immi/ui/lib/utils";

const badgeVariants = cva(
  "inline-flex w-fit shrink-0 items-center justify-center gap-1 rounded-full border px-2 py-0.5 text-xs font-medium whitespace-nowrap transition-colors [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-3",
  {
    variants: {
      variant: {
        neutral: "border-neutral-200 bg-neutral-50 text-ink-muted",
        brand: "border-brand-200 bg-brand-50 text-brand-700",
        success:
          "border-feedback-success-border bg-feedback-success-bg text-feedback-success-text",
        warning:
          "border-feedback-warning-border bg-feedback-warning-bg text-feedback-warning-text",
        danger:
          "border-feedback-error-border bg-feedback-error-bg text-feedback-error-text",
        info: "border-feedback-info-border bg-feedback-info-bg text-feedback-info-text",
        outline: "border-neutral-200 bg-transparent text-ink-body",
      },
    },
    defaultVariants: {
      variant: "neutral",
    },
  },
);

type BadgeProps = React.ComponentProps<"span"> &
  VariantProps<typeof badgeVariants> & {
    asChild?: boolean;
  };

function Badge({ className, variant, asChild = false, ...props }: BadgeProps) {
  const Comp = asChild ? Slot.Root : "span";

  return (
    <Comp
      data-slot="badge"
      data-variant={variant}
      className={cn(badgeVariants({ variant }), className)}
      {...props}
    />
  );
}

export { Badge, badgeVariants };
export type { BadgeProps };
